<template>
  <div v-on:click.stop="pageClicked()">
      <DivToVueComponent id="header" ref="header">

          <ScrollOrSelect
                  :data="getAvailableSportsList()"
                  :open="openedSport"
                  translation-type="sports"
                  class="header-menu darkest-blue"
                  bg-color-arrows="darkest-blue"
                  font-weight="font-medium"
                  @menuClicked="openFeed"
          />

          <DateMenu
                  :open="openedDate"
                  @openDate="openDate"
                  class="header-menu darkest-blue font-semi-bold"
                  @refreshFeed="getFeed(true, true)"
          />

          <ScrollOrSelect
                  :data="availableMarketList"
                  :open="openedMarket"
                  translation-type="markets"
                  class="header-menu dark-blue"
                  bg-color-arrows="dark-blue"
                  font-weight="font-semi-bold"
                  @menuClicked="openMarket"
          />
      </DivToVueComponent>
      <div class="loading" v-if="isLoading" :style="loadingCss()">
          <b-spinner style="width: 110px; height: 110px;" label="Large Spinner" type="grow" variant="primary"></b-spinner>
      </div>
      <MainView v-else
                :openedFeed="feeds"
                :openedDate="openedDate"
                @refreshFeed="getFeed(false, true)"
                :style="'height: ' + mainViewHackedHeight + 'px'"
      />


      <DivToVueComponent id="footer" class="darkest-blue" ref="footer">
          <span class="font-semi-bold-italic" v-if="showLogo">{{translate('general', 'Powered by', language)}}</span>
          <img src="/BT_logo.png" alt="Betting Top 10" title="Betting Top 10" v-if="showLogo">
      </DivToVueComponent>


      <DivToVueComponent ref="scrollerHack" id="scrollerHack" :class="(isMobile)? 'table-second-column-mobile' : 'table-third-column'" v-on:scroll.native="handleScroll" :style="'bottom: ' + footerHeight + 'px;'">
          <div :style="'width:'+hackedWidth+'px'">.</div>
      </DivToVueComponent>
  </div>
</template>

<script>
import DateMenu from './DateMenu'
import { mapGetters } from 'vuex'
import MainView from "./MainView";
import { feed, fetchSports } from '../services/FeedService'
import { tracking } from '../services/Tracking'
import DivToVueComponent from "./DivToVueComponent";
import ScrollOrSelect from "./ScrollOrSelect";
const _ = require('lodash')

export default {
    name: 'Dashboard',
    components: {
      ScrollOrSelect,
      DivToVueComponent,
      DateMenu,
      MainView,
    },
    computed: {
        ...mapGetters({
            hackedWidth: 'counters/hackedWidth',
            availableMarketList: 'counters/availableMarketList',
            cssWidthOfMarket: 'counters/cssWidthOfMarket',
            isMobile: 'settings/isMobile',
            windowHeight: 'settings/windowHeight',
            defaultSport: 'settings/defaultSport',
            baseSport: 'settings/baseSport',
            language: 'settings/language',
            firstDateWithMatch: 'counters/firstDateWithMatch',
            firstMarket: 'counters/firstMarket',
            trackingUrl: 'settings/trackingUrl',
            showLive: 'settings/showLive',
            liveCount: 'settings/liveCount',
            maxMatchesCount: 'settings/maxMatchesCount',
            googleEventLabel: 'settings/googleEventLabel',
            focusName: 'settings/focusName',
            showOnOpenSport: 'settings/showOnOpenSport',
            openedDate: 'settings/openedDate',
            focusOnLoad: 'settings/focusOnLoad',
        })
    },
    data() {
      return {
          feeds: {},
          sportsList: {},
          openedSport: null,
          openedFeed: null,
          openedMarket: null,
          firstSportFetch: true,
          isLoading: true,
          footerHeight: 0,
          mainViewHackedHeight: 0,
          showLogo: true,
      }
    },
    watch: {
        'isMobile': function () {
            this.calcMainViewHeight()
        },
        'openedSport': function () {
            this.$store.dispatch('settings/setOpenedSport', this.openedSport)
        },
        'windowHeight': function () {
            this.calcMainViewHeight()
        },
        'availableMarketList': function() {
            if(!this.openedMarket){
                let firstMarketByKey = Object.keys(this.availableMarketList)[0]
                this.openedMarket = this.availableMarketList[firstMarketByKey].name
            }
        },
    },
    methods: {
        loadingCss() {
            let height = 'height: ' + this.mainViewHackedHeight + 'px;'
            let paddingTop = 'padding-top:'+ ((this.mainViewHackedHeight/2) - 55) +'px;'
            let paddingLeft = 'padding-left: calc(50% - 55px);'
            return height + paddingTop + paddingLeft
        },
        calcMainViewHeight() {
            let headerHeight = this.$refs.header.$el.clientHeight
            this.footerHeight = this.$refs.footer.$el.clientHeight
            this.mainViewHackedHeight = this.windowHeight - (headerHeight + this.footerHeight)
        },
      getFeed(withLoading, forcedDate) {
          if(this.focusOnLoad && !forcedDate) {
            forcedDate = true
            this.$store.dispatch('settings/setUrlParam', {key: 'focusOnLoad', value: false})
          }
          withLoading = withLoading !== false
          if(withLoading){
              this.isLoading = true
          }
          let focusName = (this.showOnOpenSport)? this.focusName : false
          feed(this.openedSport, this.openedDate, this.showLive, this.liveCount, this.maxMatchesCount, focusName).then(response => {
              this.feeds = response['odds']
              Object.freeze(this.feeds)
              this.isLoading = false
              this.$store.dispatch('counters/newCounts', response)
              this.openedMarket = this.firstMarket
              if(!forcedDate){
                  this.$store.dispatch('settings/setOpenedDate', this.firstDateWithMatch)
                  this.getFeed(false, true)
              }
          })
      },
      getSportsList(){
          fetchSports(this.maxMatchesCount).then(response => {
              this.sportsList = response
              if(!Object.prototype.hasOwnProperty.call(this.sportsList, this.defaultSport) && this.firstSportFetch){
                  this.firstSportFetch = false
                  this.openFeed(this.baseSport)
              }
          })
      },
      getAvailableSportsList() {
          let intCodeFor_a = 97
          let intCodeForOrderedLetter = intCodeFor_a
          let orderedSport = {}
          _.forEach(this.sportsList, (count, sport) =>{
              if(count > 0){ _.assign(orderedSport, {[String.fromCharCode(intCodeForOrderedLetter)] : {name: sport, value: count}})}
              intCodeForOrderedLetter++
          })
          return orderedSport
      },
      openFeed(sport) {
          this.$store.dispatch('settings/setMixParlayFalse')
          this.openedSport = sport
          this.getFeed()
      },
      openMarket(market) {
          this.openedMarket = market

        let positionInMarkets = 0
         _.forEach(this.availableMarketList, (availableMarket) => {
          if(availableMarket.name === market){
            return false
          }
           positionInMarkets++
        })
        let positionLeft = positionInMarkets * this.cssWidthOfMarket
        this.$el.querySelector('#scrollerHack').scrollLeft = positionLeft
        this.$store.dispatch('settings/setMarketClicked', market)
      },
      openDate(date) {
          this.$store.dispatch('settings/setOpenedDate', date)
          this.getFeed(true, true)
      },
      handleScroll(e) {
          _.forEach(this.$el.querySelectorAll('.div-scroll-hacked'), (element) => {
              element.scrollLeft = e.target.scrollLeft
          })
      },
        handleUrlParams() {
            let queryString = window.location.search;
            let urlParams = new URLSearchParams(queryString);
            let params = {
                trackingLinkId: urlParams.get('trackingLinkId'),
                googleEventLabel: urlParams.get('googleEventLabel') === null? 'Banner Default' : urlParams.get('googleEventLabel'),
                showLive: !urlParams.get('showLive') || urlParams.get('showLive') === 'true',
                liveCount: urlParams.get('liveCount'),
                oddsFormat: urlParams.get('oddsFormat'),
                language: urlParams.get('language'),
                defaultSport: urlParams.get('defaultSport'),
                maxMatchesCount: urlParams.get('maxMatchesCount') === null? 0 : urlParams.get('maxMatchesCount'),
                focusName: urlParams.get('focusName'),
                focusMenuTitle: urlParams.get('focusMenuTitle'),
                focusSport: urlParams.get('focusSport'),
                focusOnLoad: urlParams.get('focusOnLoad') === 'true',
            }
            tracking(params.trackingLinkId, params.language).then(response => {
                this.$store.dispatch('settings/setTrackingUrl', response.trackingUrl)
            })
            this.showLogo = !urlParams.get('showLogo') || urlParams.get('showLogo') === 'true'
            this.$store.dispatch('settings/setUrlParams', params)
        },
        pageClicked() {
            this.$gtag(this.googleEventLabel)
            window.open(this.trackingUrl)
        }
    },
    updated() {
        this.calcMainViewHeight()
    },
    created() {
        this.handleUrlParams();
    },
    mounted () {
        window.addEventListener('translation-loaded', () => this.$store.dispatch('settings/translationLoaded'))
        this.openedSport = this.defaultSport
        this.getSportsList();
        this.calcMainViewHeight()
        setInterval(() => this.getFeed(false, true), 20 * 1000)
        setInterval(() => this.getSportsList(), 2 * 60 * 1000)
    }
}
</script>